import store from "store/store";

export const researchRolesSelectors = {
	error: (state = store.getState()) => state.researchRoles.error,
	content: (state = store.getState()) => state.researchRoles.content,
	isFetching: (state = store.getState()) => state.researchRoles.isFetching,
	isChanged: (state = store.getState()) => state.researchRoles.content.isChanged,
};
